import * as React from 'react'
import { Button, Tooltip } from '~/components/_atoms/index'
import YnsIcon from '~/components/icons/YnsIcon'
import Spinner from '~/components/shared/Spinner'
import { useTranslation } from '~/hooks/useTranslation'
import { getApi } from '~/util/api'

export function DeleteCell({ row, table }) {
  const chat = row.original
  const { t } = useTranslation()
  const [isDeleting, setIsDeleting] = React.useState(false)
  const setChatHistories = table.options.meta?.setChatHistories
  const toast = table.options.meta?.toast
  const chatId = chat.id

  const handleDeleteChat = async () => {
    if (window.confirm(t('chat_histories.delete_chat_confirm'))) {
      setIsDeleting(true)
      try {
        const response = await getApi().delete(
          `/chat_histories/${chatId}/api_delete`,
        )
        if (response.data.success) {
          toast({ description: response.data.message })
          // Refresh chat histories after successful deletion
          const historiesResponse = await getApi().get(
            '/coach_services/chat_histories',
          )
          if (historiesResponse.status === 200) {
            setChatHistories(historiesResponse.data.chat_histories)
          }
        }
      } catch (error) {
        console.error('Error deleting chat:', error)
        toast({
          description: 'Failed to delete chat. Please try again.',
        })
      } finally {
        setIsDeleting(false)
      }
    }
  }

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">
          <Tooltip content={t('chat_histories.delete')}>
            <Button
              variant="ghost"
              color="destructive"
              size="sm"
              startIcon={<YnsIcon name="trash" className="!h-6 !w-6" />}
              onClick={() => handleDeleteChat()}
              disabled={isDeleting}
              endIcon={isDeleting ? <Spinner show size={4} /> : null}
              className="[&>div>svg]:!h-6 [&>div>svg]:!w-6 [&_.btn-label]:hidden @md:[&_.btn-label]:inline-block"
            >
              {t('chat_histories.delete')}
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
